// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wr","image":"e_xr","imageImage":"e_yr","description":"e_zr","title":"e_Ar","button":"e_Br"};